// extracted by mini-css-extract-plugin
export var closeButton = "_ky-1";
export var closeX = "_ky-3";
export var container = "_ky-0";
export var image = "_ky-2";